import { render } from "./AvatarImage.vue?vue&type=template&id=3d48e3b4"
import script from "./AvatarImage.vue?vue&type=script&lang=js"
export * from "./AvatarImage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__